<template >
    <div class="garyaBg  montserrat overflow-hidden z-50 h-full">

        <section class="w-full flexmobile2 text-white md:h-full background-bakery">
    <div class="container md:mx-auto  md:py-44 lg:py-24">
      <div class=" flexmobile2  lg:flex-row items-center ">
        <div class="lg:w-1/2 mb-8 lg:mb-0">
          <h1 class="text-3xl sm:text-md md:text-4xl lg:text-5xl font-bold mb-6">
            Celéste French Patisserie
                  </h1>
          <h2 class="text-2xl md:text-3xl lg:text-4xl font-medium">
            Bakery Delivery Mobile Application          </h2>
        </div>
        <div class="lg:w-full flex justify-center animate__animated animate__zoomInRight ml-60">
          <img
          loading="lazy"
            src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726663664/bakery_ccvisc.png"
            alt="Eater Chicago website mockup"
            class="w-full  mx-auto"
            style="scale: 1.3;"
          />
        </div>
      </div>
    </div>
  </section>
  <!-- end of first hero section -->
  <div class="flex flexmobile2 flex-col ">
    <main class="flex flexmobile2 flex-col items-start px-4 md:px-20   w-full">
      
        <!-- section two -->
      <section class="md:w-full md:mt-10">
        <div class="flex flexmobile2 flex-col md:flex-row justify-between">
          <div class="w-full md:w-6/12">
            <section class="flex flex-col rounded-none ">
      <h1 class="self-start text-4xl font-semibold text-white">My Role</h1>
      <ul class="pt-6 text-lg  w-full flexmobile2  text-white max-md:max-w-full">
      <li class=" pt-6 text-lg ">
        <span class="text-red-300">Ideated</span> and brainstormed the <span class="text-red-300">product concept</span> and <span class="text-red-300">defined the problem statement</span>
      </li>
      <li class=" pt-6 text-lg ">
        Conducted <span class="text-red-300">contextual inquiries, interviews</span> and performed <span class="text-red-300">competitive analysis</span>
      </li>
      <li class=" pt-6 text-lg ">
        Created <span class="text-red-300">personas, wireframes & prototypes</span>
      </li>
      <li class=" pt-6 text-lg ">
        Integrated <span class="text-red-300">accessibility features</span> like dark mode, voice command and language switching
      </li>
      <li class=" pt-6 text-lg ">
        Conducted <span class="text-red-300">usability testing</span> & iterations
      </li>
    </ul>
    </section>
          </div>
          <div class="mobile-hidden">
            <img loading="lazy" class="" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726663764/Line_1_3_yea5bl.png" alt="">
          </div>
          <aside class="flex flexmobile2 flex-col ml-0 md:ml-5 w-full md:w-3/12 mt-10 md:mt-0">
            <div class="flex flex-col items-start text-3xl md:text-4xl  text-white">
              <h1 class="self-start text-4xl font-semibold text-white">Duration</h1>
              <p class="pt-6 text-lg ">8 weeks</p>
              <h1 class="self-start text-4xl font-semibold text-white pt-6 md:pt-16">Individual Project</h1>
              <h1 class="self-start text-4xl font-semibold text-white pt-6 md:pt-16">Tools</h1>
              <p class="pt-6 text-lg ">
                Zoom,Google Sheets & Docs, Miro, Figma </p>
            </div>
          </aside>
        </div>
      </section>
      <!-- end of section two -->
    </main>
  </div>
  <!-- Add responsiveness to other sections similarly -->
          <div>
          <main>
          <!-- section four -->
          <section class="mt-32 px-10 background-bakery2 h-[200px]  ">
            <div class="p-10 flexmobile flex justify-between items-center text-center">
             <div class="">
                <p class="text-white text-xl md:text-2xl">Net Promoter Score</p>
                    <p class="text-white pt-2 text-3xl md:text-5xl font-bold">9/10</p>
             </div>
             <div>
                <p class="text-white text-xl md:text-2xl">Customer Satisfaction Score</p>
                    <p class="text-white pt-2 text-3xl md:text-5xl font-bold">4.7</p>
             </div>
             <div>
                <p class="text-white text-xl md:text-2xl">Task Success Rate </p>
                    <p class="text-white pt-2 text-3xl md:text-5xl font-bold">98%</p>
             </div>
            </div>
          </section>
          <!-- end of four -->
          </main>
          </div>
          <main class=" flexmobile  mx-auto px-20">
          <!-- five section  -->
          <section class="w-full mt-44">
  <div class="flex flex-col gap-56 md:flex-row justify-between">
    <!-- Left Section -->
    <div class="w-full md:w-9/12">
      <section class="flex flex-col rounded-none max-w-[917px]">
        <h1 class="self-start text-4xl font-semibold text-white">Research Questions</h1>
        <ol class=" list-decimal w-full text-white max-md:max-w-full ml-8 mt-4">
          <li class="pt-6 text-lg ">How long does it take for users to browse food & drinks and add it to their cart?</li>
          <li class="pt-6 text-lg ">How long does the user take to complete the payment process?</li>
          <li class="pt-6 text-lg ">What kind of features would the customer like to have in a food delivery app?</li>
          <li class="pt-6 text-lg ">What do users think of notifications? Does it help them save time?</li>
        </ol>
      </section>

      <section class="flex mt-44 flex-col rounded-none">
        <h1 class="self-start text-4xl font-semibold text-white">Research Methodology</h1>
        <p class="text-red-300 text-2xl md:text-3xl font-semibold pt-6 md:pt-16">Moderated usability study</p>
        <ul class="w-full text-white max-md:max-w-full mt-8">
          <li class="pt-6 text-lg">Location: United States, remotely over zoom</li>
          <li class="pt-6 text-lg">8 participants completed the browsing, ordering and payment process on their own over a zoom call.</li>
          <li class="pt-6 text-lg">Each participant answered a series of short questions based on their experience and gave feedback.</li>
          <li class="pt-6 text-lg">Each session lasted 30 minutes and included an introduction, list of tasks and a short questionnaire.</li>
        </ul>
      </section>
    </div>

    <!-- Right Aside -->
    <aside class="flex dancing-script flex-row mx-auto w-full md:w-4/12 mt-10 md:mt-0">
      <div class="flex flex-col justify-center mobile-hidden">
        <img loading="lazy" class="" src="https://res.cloudinary.com/dvkj5orhe/image/upload/v1732246438/x38anzj7w6rwz9eornkj.png" alt="">
      </div>
      <ul class="flex flex-col justify-center ml-8 w-full text-3xl text-red-300 max-md:max-w-full">
        <li class="pt-4">Time taken to complete the task</li>
        <li class="pt-4">Use of navigation vs search bar</li>
        <li class="pt-4">User error rates</li>
        <li class="pt-4">Net Promoter score</li>
      </ul>
    </aside>
  </div>
</section>

      <!-- end -->
</main>
        <!-- section sex -->
            <section class="flex flexmobile  mt-44 px-20 mx-auto flex-col rounded-none">
          <h1 class="self-start text-4xl font-semibold text-white">Affinity Diagram from Interviews</h1>
          <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726663891/board_i4twrz.png" alt="">
        
    </section>

          <!-- section seven -->
          <section class=" text-white text-lg  flexmobile2 mt-10  mx-auto md:px-20">
          <h1 class="self-start text-4xl font-semibold text-white">Defining the Problem</h1>
          <p class="pt-6 md:pt-16 text-lg md:pb-6">Busy professionals regularly order food for delivery due to limited time for cooking and need a faster way to customize meals and place orders efficiently. Often, they must add extra items to meet delivery minimums, which isn't ideal. A quicker browsing experience for food and drink menus, along with seamless payment options, 
        is essential as they're on a time crunch.</p>
        <p class="pt-6 text-lg md:pb-6">Students on a budget look for deals and discounts to save money on food. They prefer picking up orders from cafés due to the high cost of delivery. However, long wait times when collecting orders can be frustrating, especially with their hectic schedules.</p>
          </section>
      <!-- section eight  -->
      <section class="mt-44 flex justify-between flexmobile2  mx-auto px-20">
      <div class="text-white w-full text-lg">
        <h1 class="self-start text-4xl font-semibold text-white">Target Audience</h1><br/><br/>
        <p><span class="pt-6 text-lg  text-red-300 md:pt-16 ">Working class professionals</span> who have a busy schedule and look for swift options to order food online.</p><br/>
        <p><span class="pt-6 text-lg md:pb-6 text-red-300">Students</span> with who live on a budget and want to avail the best deals to save money.</p>
      </div>
      <div>
        <img class="relative cupcake md:bottom-10 md:left-32" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726663915/20_vgijhe.png" alt="Cupcake" />
      </div>
    </section>
  <!-- section 9 -->
   <section class=" flexmobile2   mx-auto px-20">
    <div>
        <h1 class="self-start text-4xl font-semibold text-white">Goal</h1>
        <section class=" w-full tracking-tight text-white max-md:max-w-full">
    <p class="pt-6 md:pt-16 text-lg ">
      Designing a technology based solution that helps users to order and pay faster as well as avail good
      <span class="text-rose-300">deals and offers</span> along with easy
      <span class="text-rose-300">customization options.</span>
    </p>
    <p class="pt-6 text-lg ">
      Integrating additional features to transition between
      <span class="text-rose-300">light or dark mode</span>, and
      <span class="text-rose-300">voice search</span> for convenience.
    </p>
    <p class="pt-6 text-lg ">
      The solution must notify the users about their order's status and allow for
      <span class="text-rose-300">tracking features.</span>
    </p>
  </section>
  <div class="mt-32">
    <h1 class="self-start text-4xl font-semibold text-white">Competitive Analysis</h1>
    <img loading="lazy" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726833761/Group_34217_1_eibr8z.png" alt="" class="pt-12">
  </div>
    </div>
  </section>
  <BakeryAppTwo/>
  <BakeryAppThree/>
</div>

        </template>


<script>
import BakeryAppTwo from './BakeryAppTwo.vue'
import BakeryAppThree from './BakeryAppThree.vue'

export default {
  name: 'BakeryProject',
  components:{
    BakeryAppTwo,
    BakeryAppThree,

  },
  mounted() {
    const cupcake = this.$el.querySelector('.cupcake');

    // Create an Intersection Observer to detect when the cupcake enters the viewport
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Add the animation class when the cupcake is in view
          cupcake.classList.add('animate__animated', 'animate__slideInDown');
        }
      });
    });

    // Observe the cupcake image
    observer.observe(cupcake);
  }
};
</script>


<style>
.background-bakery{
  background: linear-gradient(180deg, #8F0124 0%, rgba(79, 8, 25, 0.60) 47.7%, rgba(47, 11, 20, 0.70) 71.56%, rgba(31, 12, 17, 0.80) 83.48%, rgba(23, 13, 15, 0.90) 89.44%, #0F0E0E 95.41%);

}
.background-bakery2{
    background-image: url("../assets/Rectangle\ 4156\ \(3\).png");
    background-size: contain;
}
.Bakery-Linear{
    background: linear-gradient(90deg, rgba(248,146,146,1) 0%, rgba(137,2,35,1) 35%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent; 
}

@media (max-width:640px){
    .flexmobile2{
        display: block;
        margin-left: 0;
        padding: 10px;
        gap: 0 !important;
        font-size: 20px;
    }
    
    .max-w-small-mobile{
        max-width: 100%;
        width: 100%;
    }
}

</style>
